import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isValidSudokuMove(grid: number[][], row: number, col: number, num: ClassValue): boolean {
  // Check row
  for (let x = 0; x < 9; x++) {
    if (num !== 0 && grid[row][x] === num) return false;
  }

  // Check column
  for (let x = 0; x < 9; x++) {
    if (num !== 0 && grid[x][col] === num) return false;
  }

  // Check 3x3 box
  const boxRow = Math.floor(row / 3) * 3;
  const boxCol = Math.floor(col / 3) * 3;
  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      if (num !== 0 && grid[boxRow + i][boxCol + j] === num) return false;
    }
  }
  return true;
}

// Utility to check the current environment
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * Debug logging function that only logs in development environment
 * @param args - Arguments to be logged (same as console.log)
 */
export function debug(...args: unknown[]): void {
  if (isDevelopment()) {
    console.log('[DEBUG]:', ...args);
  }
}
